<template>
  <footer class="Footer">
    <div class="Footer_content">
      <!-- Footer Logo -->
      <div class="Footer_logo">
        <img class="f-logo" src="@/assets/Logo/logo3.png" alt="Logo">
      </div>

      <!-- Footer Links -->
      <router-link to="/termsofuse" class="Footer_link">{{ $t('TERMS & CONDITIONS') }}</router-link>
      <router-link to="/contact" class="Footer_link">{{ $t('CONTACT US') }}</router-link>
      <router-link to="/privacy-info" class="Footer_link">{{ $t('PRIVACY INFO') }}</router-link>
      <router-link to="/cookie-statement-parents" class="Footer_link">{{ $t('COOKIE STATEMENT') }}</router-link>
    </div>

    <!-- Footer Disclaimer -->
    <div class="Footer_disclaimer">

      <p class="Footer_disclaimer_text">
        {{ $t('Gamestation is a free online games platform specially created for young players. We work closely together with game developers to present the latest free online games for kids. We\'re passionate about making sure it\'s a super safe environment for kids to play and enjoy themselves. Let\'s play') }}
      </p>

      <span>
        <a href="/" rel="noreferrer nofollow noopener" target="_blank">
          <img src="@/assets/certficate.png" alt="certificate" height="40" loading="lazy" width="110">
        </a>
      </span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>
